export default __webpack_public_path__ + "static/media/TENTACION.9c0b5698.jpeg";